import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { AuthenticationActions, ISignInAction } from '../../state/authenticationActions';
import { selectIsCheckingAuthentication, selectIsLoggedIn } from '../../state/authenticationSelectors';
import { StyledLogin } from './Login.styles';
import { RoutePaths } from 'config/route-paths';
import { PrimaryButton } from 'lib/components/Button/PrimaryButton/PrimaryButton';
import { LoadingPage } from 'lib/components/LoadingPage/LoadingPage';

export const Login = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isCheckingAuthentication = useSelector(selectIsCheckingAuthentication);

  const onLogin = useCallback((): ISignInAction => dispatch(AuthenticationActions.signIn()), [dispatch]);

  useEffect(() => {
    dispatch(AuthenticationActions.checkAuthentication());
  }, [dispatch]);

  if (isCheckingAuthentication) {
    return <LoadingPage />;
  }

  if (isLoggedIn) {
    return <Navigate to={RoutePaths.ROOT} replace />;
  }

  return (
    <StyledLogin className="login">
      <PrimaryButton size="m" className="login__login-button" onClick={onLogin}>
        {t('login.loginButton')}
      </PrimaryButton>
    </StyledLogin>
  );
};
